/* eslint-disable import/no-unused-modules */
import { useEffect } from "react";
import { useLazyGetEdmDocumentStatusQuery } from "../../reduxStore/api/apiSlice";
import { useAppDispatch } from "../../reduxStore/reduxHooks";
import { setConfigData } from "../../reduxStore/slices/configSlice";
import { CONFIG_DATA_KEY } from "../../utility/enums/common";
import { isTaskEnabledByAppConfig } from "../../utility/app-config-helper";
import { LETTER_OF_INTENT_TASK_ID } from "../../config/appConfigConstants";
import { useGetApplicationId } from "./useGetApplicationId";
import { useGetCandidateData } from "./useGetCandidateData";

/**
 * Initialize Letter of Intent state
 * Fetches and stores the status in Redux
 */
export const useInitializeLetterOfIntent = () => {
  const applicationId = useGetApplicationId();
  const dispatch = useAppDispatch();
  const candidateData = useGetCandidateData();

  const [triggerFetch, result] = useLazyGetEdmDocumentStatusQuery();

  useEffect(() => {
    if (candidateData?.candidateId && isTaskEnabledByAppConfig(LETTER_OF_INTENT_TASK_ID, applicationId)) {
      triggerFetch({
        documentType: "letterOfIntentApplicationStates",
        candidateGlobalId: candidateData.candidateId,
        applicationId,
      });
    }
  }, [candidateData, applicationId, triggerFetch]);

  useEffect(() => {
    if (result.data) {
      dispatch(
        setConfigData({
          key: CONFIG_DATA_KEY.LETTER_OF_INTENT,
          value: result.data,
        })
      );
    }
  }, [result.data, dispatch]);

  return result;
};
